import { defineComponent as B, ref as S, inject as U, computed as s, openBlock as r, createElementBlock as l, normalizeClass as P, createElementVNode as a, withDirectives as M, vShow as T, createCommentVNode as i, toDisplayString as o, createBlock as E, resolveDynamicComponent as I, unref as n, createTextVNode as v, Fragment as Y, renderList as F } from "vue";
import { useDateFormat as q } from "@vueuse/core";
import { $ as L } from "./chunks/FrontiersClibConfigService.5b50b8d0.js";
import { a as $ } from "./chunks/Numbers.0dd1fb08.js";
import './assets/index21.css';const G = ["href", "data-event"], J = { class: "CardArticle__mask CardArticle__mask--hzt" }, K = ["src", "alt"], O = { class: "CardArticle__info" }, Q = {
  key: 0,
  class: "CardArticle__pdfLabel"
}, R = { class: "CardArticle__header" }, W = { class: "CardArticle__type" }, X = { class: "CardArticle__date" }, Z = {
  key: 1,
  class: "CardArticle__section"
}, x = { class: "CardArticle__authors notranslate" }, ee = ["innerHTML"], te = ["innerHTML"], ae = /* @__PURE__ */ a("div", { class: "CardArticle__spacer" }, null, -1), se = { class: "CardArticle__mask CardArticle__mask--vrt" }, re = ["src", "alt"], le = { class: "CardArticle__journal" }, oe = ["innerHTML"], ie = { class: "CardArticle__journal__doi notranslate" }, ne = { class: "CardArticle__metrics" }, ce = {
  key: 0,
  class: "CardArticle__metrics__item"
}, ue = {
  key: 1,
  class: "CardArticle__metrics__item"
}, C = 10, pe = /* @__PURE__ */ B({
  __name: "CardArticle",
  props: {
    id: {},
    doi: {},
    title: {},
    type: {},
    publishedDate: {},
    acceptedDate: {},
    journalName: {},
    journalSlug: {},
    useNewUrl: { type: Boolean },
    section: {},
    authors: {},
    totalViews: {},
    totalCitations: {},
    imageUrl: {},
    showPdfTag: { type: Boolean },
    skin: {},
    heading: { default: "h3" }
  },
  setup(N) {
    const t = N, g = S(!1), u = U("sanitize"), A = (e, d, c = "s") => `${e}${d !== 1 ? c : ""}`, H = s(() => {
      const e = t.publishedDate ? t.publishedDate : t.acceptedDate, d = t.publishedDate ? "Published" : "Accepted", c = q(e, "DD MMM YYYY");
      return `${d} on ${c.value}`;
    }), f = s(() => t.totalViews ? t.totalViews >= 100 : !1), w = s(() => t.totalCitations ? t.totalCitations > 0 : !1), j = s(() => t.useNewUrl && t.journalSlug ? `https://www.${L.getMainDomain}/journals/${t.journalSlug}/articles/${t.doi}/full` : `https://www.${L.getMainDomain}/articles/${t.doi}/full`), _ = s(() => !!(t.imageUrl && g.value)), V = s(() => !!(f.value || w.value)), b = s(() => {
      const e = ["CardArticle"];
      return _.value && e.push("CardArticle--hasImg"), V.value && e.push("CardArticle--hasMetrics"), k.value && e.push("CardArticle--horizontal"), e;
    }), k = s(() => t.skin === "Horizontal"), h = s(() => {
      var e;
      return ((e = t.authors) == null ? void 0 : e.length) > C;
    }), m = s(() => {
      var e;
      return h.value ? ((e = t.authors) == null ? void 0 : e.length) - C : 0;
    }), p = s(() => h.value ? t.authors.slice(0, C - 1) : t.authors), D = s(() => h.value ? t.authors[t.authors.length - 1] : null), y = () => {
      g.value = !0;
    };
    return (e, d) => (r(), l("article", {
      class: P(b.value)
    }, [
      a("a", {
        class: "CardArticle__wrapper",
        href: j.value,
        "data-event": e.$ga.getDataEventValue("cardArticle", "a", e.doi)
      }, [
        M(a("figure", J, [
          a("img", {
            class: "CardArticle__mask__img",
            src: e.imageUrl,
            alt: e.title,
            onLoad: y
          }, null, 40, K)
        ], 512), [
          [T, _.value && k.value]
        ]),
        a("div", O, [
          e.showPdfTag ? (r(), l("p", Q, "PDF-read only")) : i("", !0),
          a("div", R, [
            a("p", W, o(e.type), 1),
            a("p", X, o(H.value), 1)
          ]),
          (r(), E(I(e.heading), {
            class: "CardArticle__title",
            innerHTML: n(u)(e.title)
          }, null, 8, ["innerHTML"])),
          e.section ? (r(), l("p", Z, [
            v(" in "),
            a("span", null, o(e.section), 1)
          ])) : i("", !0),
          a("ul", x, [
            (r(!0), l(Y, null, F(p.value, (c, z) => (r(), l("li", {
              key: z,
              innerHTML: n(u)(c.fullName)
            }, null, 8, ee))), 128)),
            m.value ? (r(), l("li", {
              key: p.value.length + m.value,
              class: "CardArticle__authors__more"
            }, o(m.value) + " more ", 1)) : i("", !0),
            D.value ? (r(), l("li", {
              key: p.value.length,
              innerHTML: n(u)(D.value.fullName)
            }, null, 8, te)) : i("", !0)
          ]),
          ae,
          M(a("figure", se, [
            a("img", {
              class: "CardArticle__mask__img",
              src: e.imageUrl,
              alt: e.title,
              onLoad: y
            }, null, 40, re)
          ], 512), [
            [T, _.value]
          ]),
          a("div", le, [
            a("div", {
              class: "CardArticle__journal__name",
              innerHTML: n(u)(e.journalName)
            }, null, 8, oe),
            a("div", ie, o(`doi ${e.doi}`), 1)
          ])
        ]),
        a("ul", ne, [
          f.value ? (r(), l("li", ce, [
            a("strong", null, o(n($)(e.totalViews)), 1),
            v(" " + o(A("view", e.totalViews)), 1)
          ])) : i("", !0),
          w.value ? (r(), l("li", ue, [
            a("strong", null, o(n($)(e.totalCitations)), 1),
            v(" " + o(A("citation", e.totalCitations)), 1)
          ])) : i("", !0)
        ])
      ], 8, G)
    ], 2));
  }
});
export {
  pe as CardArticle
};
